export { default } from "./SkillGroupHeading";
